import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@icon/plus.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicInput = _resolveComponent("BasicInput")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    key: _ctx.formKey,
    ref: "form",
    class: "add-input",
    onSubmitю: _withModifiers(_ctx.onEnter, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BasicInput, {
        ref: "basicInput",
        id: "addCustomInput",
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        placeholder: "Add Custom...",
        class: "add-input__item",
        name: "addCustomInput",
        rules: _ctx.rules
      }, null, 8, ["modelValue", "rules"]),
      _createElementVNode("button", {
        type: "submit",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)))
      }, [
        _createVNode(_component_icon, {
          data: _imports_0,
          color: "#336DFF",
          width: "1.5em",
          height: "1.5em"
        })
      ])
    ]),
    _: 1
  }, 8, ["onSubmitю"]))
}